import { customerMediaSelector, internalMediaSelector, supplierMediaSelector } from '@synergy/data-access';

import { activitiesSelector } from '../../selectors/activity-selectors';
import { receiptInternalNotesSelector } from '../../selectors/internal-notes-selectors';
import { useAppSelector } from '../../../store/use-appstate-selector';

export interface PaloDockCounts {
    activities: number;
    notes: number;
    /** Every file of the document, whichever side it belongs to. */
    attachments: number;
}

/**
 * Counts for the activity dock's tabs. The prototype puts a number on every
 * tab; these come from the same stores the panels render, so a tab can never
 * promise entries the panel does not show.
 */
export const usePaloDockCounts = (): PaloDockCounts => {
    const activities = useAppSelector(activitiesSelector);
    const notes = useAppSelector(receiptInternalNotesSelector);
    const customerMedia = useAppSelector(customerMediaSelector);
    const supplierMedia = useAppSelector(supplierMediaSelector);
    const internalMedia = useAppSelector(internalMediaSelector);

    return {
        activities: activities.length,
        notes: notes.length,
        attachments: customerMedia.length + supplierMedia.length + internalMedia.length,
    };
};
